import React, { useEffect, useState } from "react";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import { Spin } from "antd";
import axios from "axios";
import config from "../../config";
import PrintHeaderAccount from "../../Pdf/PrintHeaderAccount";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { PrintFormateNumber } from "../../Pdf/PrintFormateNumber";
import pdfStyles from "../../Pdf/pdfStyles";
import PrintFooter from "../../Pdf/PrintFooter";

function PrintAccountList() {
  const params = useParams();

  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  const [loading, setLoading] = useState(false);
  const [listOfReading, setListOfReading] = useState([]);
  const [Printdata, setPrintdata] = useState([]);
  const [saleDetail, setSaleDetail] = useState([]);

  useEffect(() => {
    document.title="Print Sale"
    setLoading(true);

    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ID: params.id,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Sale/GetSaleByID",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setPrintdata(response.data);
          setListOfReading(response.data.listofReadings);
          setSaleDetail(response.data.listofSale);
          setLoading(false);
        } else {
          // Handle error
        }
        // setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const readingData = () => {
    if (listOfReading != null && listOfReading.length > 0) {
      return listOfReading.map((item, index) => {
        return (
          <View key={index} style={pdfStyles.row}>
            <View style={[pdfStyles.td, { width: 50 }]}>
              <Text style={pdfStyles.tdValue}>{index + 1}</Text>
            </View>

            <View style={[pdfStyles.td, { width: 50 }]}>
              <Text style={pdfStyles.tdValue}>{item.Pump_No}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 100 }]}>
              <Text style={pdfStyles.tdValue}>{item.ProductName}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 90 }]}>
              <Text style={pdfStyles.tdValue}>{item.Last_Reading}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 90 }]}>
              <Text style={pdfStyles.tdValue}>{item.Current_Reading}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 90 }]}>
              <Text style={pdfStyles.tdValue}>{item.Returned}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 90 }]}>
              <Text style={pdfStyles.tdValue}>
                {PrintFormateNumber(
                  item.Current_Reading - item.Last_Reading - item.Returned
                    ? item.Current_Reading - item.Last_Reading - item.Returned
                    : 0,
                  2
                )}
              </Text>
            </View>
          </View>
        );
      });
    }
  };

  const salesDetails = () => {

    if (saleDetail != null && saleDetail.length > 0) {
      return saleDetail.map((item, index) => {
        return (
          <View key={index} style={pdfStyles.row}>
            <View style={[pdfStyles.td, { width: 50 }]}>
              <Text style={pdfStyles.tdValue}>{index + 1}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 50 }]}>
              <Text style={pdfStyles.tdValue}>{item.Receipt_No}</Text>
            </View>

            <View style={[pdfStyles.td, { width: 100 }]}>
              <Text style={pdfStyles.tdValue}>{item.Product_BE?.Name}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 80 }]}>
              <Text style={pdfStyles.tdValue}>{item.Account_BE?.Name}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 50 }]}>
              <Text style={pdfStyles.tdValue}>{item.Vehicle_No}</Text>
            </View>
           
            <View style={[pdfStyles.td, { width: 50 }]}>
              <Text style={pdfStyles.tdValue}>{item.Quantity}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 50, textAlign: "right" }]}>
              <Text style={pdfStyles.tdValue}>{item.Price}</Text>
            </View>
            <View style={[pdfStyles.td, { width: 50, textAlign: "right" }]}>
              <Text style={pdfStyles.tdValue}>
                {item.Price == true ? "YES" : "NO"}
              </Text>
            </View>
            <View style={[pdfStyles.td, { width: 80, textAlign: "right" }]}>
              <Text style={pdfStyles.tdValue}>
                {PrintFormateNumber(item.Amount, 0)}
              </Text>
            </View>
          </View>
        );
      });
    }
  };

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <PrintHeaderAccount />
        <View style={pdfStyles.topData}>
          <View>
            <Text style={{ fontSize: "12pt" }}>
              Invoice No:{Printdata.InvoiceNo}
            </Text>
          </View>
          <View>
            <Text style={{ fontSize: "12pt" }}>
              Date: {dayjs(Printdata.Dated).format("DD-MMM-YYYY").toLowerCase()}
            </Text>
          </View>
        </View>
        <View style={pdfStyles.topData}>
          <View>
            <Text style={{ fontSize: "12pt" }}>
              Description:{Printdata.Description}
            </Text>
          </View>
        </View>
        <View style={pdfStyles.section}>
          <View style={pdfStyles.title}>
            <Text style={pdfStyles.pagetitle}>Sales Report</Text>
          </View>
          <View style={pdfStyles.table}>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 50 }]}>
                <Text style={pdfStyles.thValue}>Sr No</Text>
              </View>
              <View style={[pdfStyles.th, { width: 50 }]}>
                <Text style={pdfStyles.thValue}>Pump No</Text>
              </View>
              <View style={[pdfStyles.th, { width: 100 }]}>
                <Text style={pdfStyles.thValue}>Product</Text>
              </View>
              <View style={[pdfStyles.th, { width: 90 }]}>
                <Text style={pdfStyles.thValue}>Last Reading</Text>
              </View>
              <View style={[pdfStyles.th, { width: 90 }]}>
                <Text style={pdfStyles.thValue}>Current Reading</Text>
              </View>
              <View style={[pdfStyles.th, { width: 90 }]}>
                <Text style={pdfStyles.thValue}>Return</Text>
              </View>
              <View style={[pdfStyles.th, { width: 90 }]}>
                <Text style={pdfStyles.thValue}>Quantity</Text>
              </View>
            </View>

            {readingData()}
          </View>
        </View>

        <View style={pdfStyles.section}>
          <View style={pdfStyles.table}>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 50 }]}>
                <Text style={pdfStyles.thValue}>Sr No</Text>
              </View>
              <View style={[pdfStyles.th, { width: 50 }]}>
                <Text style={pdfStyles.thValue}>Receipt no</Text>
              </View>
              <View style={[pdfStyles.th, { width: 100 }]}>
                <Text style={pdfStyles.thValue}>Product</Text>
              </View>
              <View style={[pdfStyles.th, { width: 80 }]}>
                <Text style={pdfStyles.thValue}>Account</Text>
              </View>
              <View style={[pdfStyles.th, { width: 50 }]}>
                <Text style={pdfStyles.thValue}>Vehicle No</Text>
              </View>
             
              <View style={[pdfStyles.th, { width: 50 }]}>
                <Text style={pdfStyles.thValue}>Quantity</Text>
              </View>
              <View style={[pdfStyles.th, { width: 50, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Price</Text>
              </View>
              <View style={[pdfStyles.th, { width: 50, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Cash</Text>
              </View>
              <View style={[pdfStyles.th, { width: 80, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Total</Text>
              </View>
            </View>

            {salesDetails()}
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 480, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Total</Text>
              </View>
              <View style={[pdfStyles.th, { width: 80, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>
                  {PrintFormateNumber(
                    Printdata.Cash_Total + Printdata.Credit_Total,
                    0
                  )}
                </Text>
              </View>
            </View>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 480, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>Cash Total</Text>
              </View>
              <View style={[pdfStyles.th, { width: 80, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>
                  {PrintFormateNumber(Printdata.Cash_Total, 0)}
                </Text>
              </View>
            </View>
            <View style={pdfStyles.tableHead}>
              <View style={[pdfStyles.th, { width: 480, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}> Credit Total</Text>
              </View>
              <View style={[pdfStyles.th, { width: 80, textAlign: "right" }]}>
                <Text style={pdfStyles.thValue}>
                  {" "}
                  {PrintFormateNumber(Printdata.Credit_Total, 0)}
                </Text>
              </View>
            </View>
          </View>
        </View>

        <View
          style={{
            marginBottom: 50,
            marginLeft: 20,
            marginTop: 0,
            top: 0,
            bottom: 10,
          }}
          fixed
        >
          <Text
            style={{ fontSize: "8pt" }}
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
          />
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <>
      <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
        {loading ? (
          <div
            style={{
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <PDFViewer width="100%" height="100%" fileName="accounts.pdf">
            <MyDocument />
          </PDFViewer>
        )}
      </div>
    </>
  );
}

export default PrintAccountList;
